import React from 'react';
import ClaimFieldsTable from './ClaimFieldsTable';
export default function CalculationsOfPayableTaxCreditTable(_ref) {
  let {
    claim,
    setClaim,
    calculations,
    refreshCalculations
  } = _ref;
  const calculationOfPayableTaxCreditRows = [{
    text: 'Trading loss generated',
    field: {
      name: 'trading_loss_generated'
    }
  }, {
    text: 'Less losses utilised against CY profits under CTA 2010 s37(3)(a)',
    field: {
      name: 'less_losses_utilized_cy_profits_cta_2010',
      editable: true
    }
  }, {
    text: 'Less losses utilised against PY profits under CTA 2010 s37(3)(b)',
    field: {
      name: 'less_losses_utilized_py_profits_cta_2010',
      editable: true
    }
  }, {
    text: 'Less losses surrendered for Group Relief under CTA 2010 s99',
    field: {
      name: 'less_losses_surrendered_for_group_relief_cta_2010',
      editable: true
    }
  }, {
    text: 'Unrelieved trading losses',
    field: {
      name: 'unrelieved_trading_losses'
    }
  }, {
    text: 'Loss surrendered for payable R&D Tax Credit',
    field: {
      name: 'loss_surrendered_for_payable_rnd_tax_credit'
    }
  }, {
    text: 'R&D Tax Credit',
    field: {
      name: 'rnd_tax_credit'
    }
  }, {
    text: 'Relevant Expenditure on Workers (Staff)',
    field: {
      name: 'expenditure_workers_staff',
      editable: true
    }
  }, {
    text: 'Relevant Expenditure on Workers (CEPWS)',
    field: {
      name: 'expenditure_workers_cepws',
      editable: true
    }
  }, {
    text: 'PAYE/NIC Cap Amount',
    field: {
      name: 'paye_nic_cap_amount'
    }
  }, {
    className: 'font-weight-bold',
    text: 'BENEFIT - Capped R&D Tax Credit',
    field: {
      name: 'benefit_capped_rnd_tax_credit'
    }
  }, {
    text: 'Loss surrendered for payable ERIS credit',
    field: {
      name: 'loss_surrendered_for_payable_eris_credit'
    },
    shouldDisplay: claim.rate_types_qualified_for.eris
  }, {
    className: 'font-weight-bold',
    text: 'BENEFIT - Payable ERIS credit',
    field: {
      name: 'benefit_payable_eris_credit'
    },
    shouldDisplay: claim.rate_types_qualified_for.eris
  }];
  return /*#__PURE__*/React.createElement(ClaimFieldsTable, {
    calculations: calculations,
    refreshCalculations: refreshCalculations,
    claim: claim,
    setClaim: setClaim,
    title: "Calculation of payable tax credit",
    rows: calculationOfPayableTaxCreditRows
  });
}